import React from "react";
import "./DropDown.scss";

interface DropDownProps {
  options: { value: string; label: string }[];
  onSelect: (value: string) => void;
  hide?: boolean;
}

export const DropDown: React.FC<DropDownProps> = ({
  options,
  onSelect,
  hide,
}) => {
  if (hide) return null;

  return (
    <div className="dropdown">
      {options.map((option) => (
        <button
          key={option.value}
          className="dropdown__item"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onSelect(option.value);
          }}
          dangerouslySetInnerHTML={{ __html: option.label }}
        ></button>
      ))}
    </div>
  );
};
